import DraggingFieldsScreenRenderer from './DraggingFieldsScreenRenderer'
export default DraggingFieldsScreenRenderer


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/DraggingFieldsScreenRenderer/index.js